export enum enumSidebarMenuItem {
  CUSTOMS,
  PRODUCTS,
  ACCOUNT,
  LCL,
  SETTINGS,
  MARINE_INSURANCE,
}
